// https://github.com/vuejs/vuex/blob/dev/examples/shopping-cart/store/modules/cart.js

const state = () => ({
  isDevMode: false
})

const getters = {
  isDevMode: state => {
    return state.isDevMode
  }
}

export default {
  namespaced: true,
  state,
  getters
}
